import React, { useState } from 'react';
import './packages.css';
import { 
  FaChevronDown, FaChevronUp, FaBus, FaCampground, FaBinoculars, 
  FaHandsHelping, FaHotel, FaMapMarkedAlt, FaPlaneDeparture 
} from 'react-icons/fa';
import { MdOutlineNaturePeople, MdVolunteerActivism } from 'react-icons/md';

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import { Trans, useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import useScrollToTop from './ScrollToTop';


const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  pauseOnHover: false,
  fade: true,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true
      }
    }
  ]
};


const DayAccordion = ({ item, isOpen, onClick }) => (
  <div className={`day-accordion${isOpen ? ' open' : ''}`}>
    <div className="day-header" onClick={onClick}>
      <h3>{item.icon} {item.day}</h3>
      <span className="toggle-icon">
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </span>
    </div>

    {isOpen && (
      <div className="day-content-row">
        <div className="day-text-content">
          <p className="highlight">{item.highlight}</p>
          <div className="details">
            {item.details.map((d, i) => <p key={i}>{d}</p>)}
          </div>
        </div>
        {item.image && (
          <div className="day-image-container">
            <img src={item.image} alt={item.day} className="day-image" />
          </div>
        )}
      </div>
    )}
  </div>
);


const PackageOsiligi = () => {
  const [openDay, setOpenDay] = useState(null);
  const toggle = idx => setOpenDay(openDay === idx ? null : idx);
  const [activeTab, setActiveTab] = useState("inclusions");

  const { t } = useTranslation('packageosiligi');
  const inclusions = t("details.inclusionsList", { returnObjects: true });
  const exclusions = t("details.exclusionsList", { returnObjects: true });
  const plannerData = t("details.planner", { returnObjects: true });

  const icons = [
    <FaBus />,
    <FaCampground />,
    <FaBinoculars />,
    <MdOutlineNaturePeople />,
    <MdVolunteerActivism />,
    <MdVolunteerActivism />,
    <MdVolunteerActivism />,
    <FaHandsHelping />,
    <FaHotel />,
    <FaBinoculars />,
    <FaPlaneDeparture />
  ];

  const images = [
    "/images/welcome.jpg",
    "/images/bonfire.jpg",
    "/images/view.JPG",
    "/images/osiligi1.jpg",
    "/images/school.jpeg",
    "/images/IMG-20250703-WA0019.jpg",
    "/images/osiligifa.jpg",
    "/images/communityinvolvement.jpg",
    "/images/VASHA.jpg",
    "/images/nakuru.jpeg",
    "/images/depart.jpg"
  ];

  const itineraryData = t('itinerary.days', { returnObjects: true }).map((item, index) => ({
    icon: icons[index],
    image: images[index],
    day: item.day,
    highlight: item.highlight,
    details: item.details
  }));

  useScrollToTop();

  return (
    <div className="package">
      
      {/* HERO SECTION */}
      <section className="package-hero">
        <img src="/images/intro.jpeg" alt="Osiligi Reserve" className="hero-image" />
        <div className="phero-overlay" />
        <div className="phero-text">
          <h1>{t("healthSafari.title")}</h1>
          <p>{t("healthSafari.subtitle")}</p>
        </div>
      </section>

      {/* INTRO */}
      <section className="package-intro">
        <div className="package-intro-content">
          <h2>{t('packageIntro.title')}</h2>
          <p>{t('packageIntro.paragraph1')}</p>
          <p>{t('packageIntro.paragraph2')}</p>
          <p>
            <Trans
              i18nKey="packageIntro.paragraph3"
              ns="packageosiligi"
              components={{ strong: <strong /> }}
            />
          </p>
        </div>
      </section>

      {/* CAROUSELS */}
      <section className="package-carousel-wrapper">
        {/* First carousel */}
        <div className="carousel-container">
          <div className="carousel-wrapper">
            <Slider {...sliderSettings}>
              <div><img src="/images/mentorship.jpg" alt="Scenic view of Mara landscape 1" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/LIONKINGS.jpg" alt="Wildlife in Mara savannah 2" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/medic.jpg" alt="Sunset over Mara plains 3" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/ELPHATIN3.JPG" alt="Elephant in Mara" className="carousel-image" loading="lazy" /></div>
            </Slider>
          </div>
        </div>

        {/* Second carousel */}
        <div className="carousel-container hide-on-mobile">
          <div className="carousel-wrapper">
            <Slider {...sliderSettings}>
              <div><img src="/images/family.JPG" alt="Family safari moments" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/lab.jpg" alt="Medical work in Mara" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/jaw.jpg" alt="Mara sunrise with acacia trees" className="carousel-image" loading="lazy" /></div>
              <div><img src="/images/school.jpeg" alt="School visit" className="carousel-image" loading="lazy" /></div>
            </Slider>
          </div>
        </div>
      </section>

      {/* ACTIVITIES */}
      <section className="activities-section">
        <div className="activities container">
          <h2 className="activities-title">{t("activities.title")}</h2>
          <div className="activities-card">
            <ul className="activities-list">
              {t("activities.list", { returnObjects: true }).map((item, index) => (
                <li key={index}>
                  <Trans
                    i18nKey={`activities.list.${index}`}
                    ns="packageosiligi"
                    components={{ strong: <strong /> }}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ITINERARY */}
      <section className="package-itinerary">
        <h2><FaMapMarkedAlt /> Program / Itinerary</h2>
        <div className="accordion-wrapper">
          {itineraryData.map((item, i) => (
            <DayAccordion
              key={i}
              item={item}
              isOpen={openDay === i}
              onClick={() => toggle(i)}
            />
          ))}
        </div>
      </section>

      {/* ACCOMMODATION */}
      <div className='accomodation-card'>
        {/* Budget */}
        <h5>{t("accommodation.onBudgetTitle")}</h5>
        <div className='onBudget-card'>
          <div className='charge-section'>
            <table>
              <thead>
                <tr>
                  <th>{t("accommodation.tableHeaders.monthsDates")}</th>
                  <th>{t("accommodation.tableHeaders.onePerson")}</th>
                  <th>{t("accommodation.tableHeaders.twoThreePeople")}</th>
                  <th>{t("accommodation.tableHeaders.fourSixPeople")}</th>
                  <th>{t("accommodation.tableHeaders.sevenPlusPeople")}</th>
                  <th>{t("accommodation.tableHeaders.youngAdult")}</th>
                  <th>{t("accommodation.tableHeaders.childUnder12")}</th>
                </tr>
              </thead>
              <tbody>
                {t("accommodation.onBudgetRows", { returnObjects: true }).map((row, index) => (
                  <tr key={index}>
                    <td>{row.monthsDates}</td>
                    <td>{row.onePerson}</td>
                    <td>{row.twoThreePeople}</td>
                    <td>{row.fourSixPeople}</td>
                    <td>{row.sevenPlusPeople}</td>
                    <td>{row.youngAdult}</td>
                    <td>{row.childUnder12}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className='accomodationImg-card'>
            <img src="/images/oseki.jpeg" alt="Budget Camp" />
          </div>
        </div>

        {/* Luxury */}
        <h5>{t("accommodation.luxuryTitle")}</h5>
        <div className='luxury-card'>
          <div className='accomodationImg-card'>
            <img src="/images/oldarpoi_room1.jpg" alt="Luxury Camp" />
          </div>
          <div className='charge-section'>
            <table>
              <thead>
                <tr>
                  <th>{t("accommodation.tableHeaders.monthsDates")}</th>
                  <th>{t("accommodation.tableHeaders.onePerson")}</th>
                  <th>{t("accommodation.tableHeaders.twoThreePeople")}</th>
                  <th>{t("accommodation.tableHeaders.fourSixPeople")}</th>
                  <th>{t("accommodation.tableHeaders.sevenPlusPeople")}</th>
                  <th>{t("accommodation.tableHeaders.youngAdult")}</th>
                  <th>{t("accommodation.tableHeaders.childUnder12")}</th>
                </tr>
              </thead>
              <tbody>
                {t("accommodation.luxuryRows", { returnObjects: true }).map((row, index) => (
                  <tr key={index}>
                    <td>{row.monthsDates}</td>
                    <td>{row.onePerson}</td>
                    <td>{row.twoThreePeople}</td>
                    <td>{row.fourSixPeople}</td>
                    <td>{row.sevenPlusPeople}</td>
                    <td>{row.youngAdult}</td>
                    <td>{row.childUnder12}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <p className='volnote'>
          <b>{t || "Note:"}</b> {t("accommodation.note")}
        </p>
      </div>

      {/* DETAILS TABS */}
      <section className="package-details-wrapper">
        <div className="left-section">
          <div className="card-container">
            {activeTab === "inclusions" ? (
              <div className="inclusions-card">
                <div className="tab-buttons">
                  <button className={activeTab === "inclusions" ? "active" : ""} onClick={() => setActiveTab("inclusions")}>
                    {t("details.tabs.inclusions")}
                  </button>
                  <button className={activeTab === "exclusions" ? "active" : ""} onClick={() => setActiveTab("exclusions")}>
                    {t("details.tabs.exclusions")}
                  </button>
                </div>
                <br />
                <h3>{t("details.tabs.inclusions")}</h3>
                <ul className="inclusions-list">
                  {inclusions.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              </div>
            ) : (
              <div className="exclusions-card">
                <div className="tab-buttons">
                  <button className={activeTab === "inclusions" ? "active" : ""} onClick={() => setActiveTab("inclusions")}>
                    {t("details.tabs.inclusions")}
                  </button>
                  <button className={activeTab === "exclusions" ? "active" : ""} onClick={() => setActiveTab("exclusions")}>
                    {t("details.tabs.exclusions")}
                  </button>
                </div>
                <br />
                <h3>{t("details.tabs.exclusions")}</h3>
                <ul className="exclusions-list">
                  {exclusions.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="planner-info">
          <img src="/images/Kikanae.jpeg" alt={plannerData.imageAlt} />
          <h4>{plannerData.name}</h4>
          <p>{plannerData.role}</p>
          <p>
            {plannerData.phoneLabel}: <a href={`tel:${plannerData.phoneNumber}`}>{plannerData.phoneNumber}</a>
          </p>
          <p>
            {plannerData.emailLabel}: <a href={`mailto:${plannerData.emailAddress}`}>{plannerData.emailAddress}</a>
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="place-cta" aria-label="Call to Action Section">
        <h2>Ready to Experience the Magic?</h2>
        <p>Book your family adventure today and explore Kenya like never before.</p>
        <Link to="/contact?source=packageosiligi" className="book-now">Book Now</Link>
      </section>
    </div>
  );
};

export default PackageOsiligi;
